/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/edit_medium'
export default icon
